export default __webpack_public_path__ + "static/multimonth-2x6-07445e4aa47b5f5cfe8ba5076514e8b6.png";